<script>
import NavBar from "@components/nav-bar";
import FooterBar from "@components/footer-bar";
import SideBar from "@components/side-bar";
import RightBar from "@components/right-bar";
import changeFavicon from "@utils/change-favicon";
import getSecret from "@utils/get-secret";
export default {
  components: { NavBar, FooterBar, SideBar, RightBar },
  data() {
    return {
      isMenuCondensed: false,
      user: this.$store ? this.$store.state.auth.currentSession.user : {} || {},
    };
  },
  watch: {
    isMenuCondensed(newVal, oldVal) {
      localStorage.setItem("isMenuCondensed", newVal);
    },
  },
  created: () => {
    document.body.style.backgroundColor = "";
    document.body.classList.remove("authentication-bg");
    document.body.classList.remove("authentication-bg-pattern");
    const host = window.location.host;
    const parts = host.split(/[:.]+/);
    const actualDomain = parts[0];
    const redColaborativaDomain = getSecret("RED_COLABORATIVA");
    if (actualDomain == redColaborativaDomain) {
      changeFavicon();
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuCondensed = !this.isMenuCondensed;
      document.body.classList.toggle("sidebar-enable");
      // if (
      //   !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
      //     navigator.userAgent
      //   )
      // )
      document.body.classList.toggle("enlarged");
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
  },
  // mounted: function(){
  // this.toggleMenu()
  // if (localStorage.getItem('isMenuCondensed') === 'true'){
  //   this.toggleMenu()
  // }
  // }
};
</script>

<template>
  <div id="wrapper">
    <NavBar :user="user" />
    <SideBar :is-condensed="isMenuCondensed" />
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->

    <div class="content-page">
      <div class="content">
        <!-- Start Content-->
        <div class="container-fluid p-1">
          <slot />
        </div>
      </div>
    </div>
    <FooterBar class="d-none" />
  </div>
</template>
